import React, { useState, useEffect } from 'react';
import { Box, Grid, Button, Typography, useTheme, useMediaQuery } from '@mui/material';
import { RoomData } from '../constant/RoomData';
import { MoreSettingRoomData } from '../constant/MoreSettingRoomData';
import { Link } from 'react-router-dom';

const Room = () => {
  const [activeButtons, setActiveButtons] = useState([]);
  const [activeMoreSettingButtons, setActiveMoreSettingButtons] = useState([]);
  const [roomData, setRoomData] = useState({});
  const theme = useTheme()
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'))

  const generateRoomData = () => {
    const data = {
      is_cold: activeButtons.includes(0),
      is_heat: activeButtons.includes(1),
      is_airconditioner: activeButtons.includes(2),
      is_humidifier: activeButtons.includes(3),
      is_music: activeButtons.includes(4),
      is_light: activeButtons.includes(5),
      is_tv: activeButtons.includes(6),
      is_modem: activeButtons.includes(7),
      is_jacuzzi: activeButtons.includes(8),
      moreSettings: activeMoreSettingButtons.map(index => index + 1)
    };
    setRoomData(data);
    console.log('Room data to send:', data);
  };

  useEffect(() => {
    generateRoomData();
  }, [activeButtons, activeMoreSettingButtons]);

  const handleButtonClick = (index) => {
    setActiveButtons((prev) =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  const handleMoreSettingButtonClick = (index) => {
    setActiveMoreSettingButtons((prev) =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };

  return (
    <div className='container' style={{ padding: '60px 40px', backgroundColor: 'white', borderRadius: '10px', boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)' }}>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <Typography variant={isLargeScreen ? 'h1' : 'h2'} align="center" color='black' sx={{ fontWeight: isLargeScreen ? 600 : 700, color: 'black', mb: '32px' }}>
          خانه
        </Typography>
        <Box
          display="grid"
          gridTemplateColumns="repeat(3, 1fr)"
          gap={2}
          mb={5}
          justifyContent="center"
          alignItems="center"
        >
          {RoomData.map((item, index) => (
            <Button
              key={index}
              onClick={() => handleButtonClick(index)}
              variant="contained"
              sx={{
                width: 80,
                height: 80,
                flexDirection: 'column',
                borderRadius: 2,
                backgroundColor: activeButtons.includes(index)
                  ? theme.palette.primary.main
                  : theme.palette.info.main,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 1,
                padding: 1,
              }}
            >
              <Box sx={{ width: '32px', height: '32px' }}>
                <img src={item.image} alt="" style={{ width: '100%', height: '100%' }} />
              </Box>
              <Typography variant="subtitle1" color="white" fontWeight="bold">
                {item.title}
              </Typography>
            </Button>
          ))}
        </Box>

        <Box maxWidth={275} textAlign="center">
          <Typography variant="subtitle1" color={theme.palette.info.dark} mb={'8px'}>
            مدیریت بیشتر اتاقک هوشمند
          </Typography>
          <Box
            display="grid"
            gridTemplateColumns="repeat(4, 1fr)"
            gap={1}
            justifyContent="center"
            alignItems="center"
          >
            {MoreSettingRoomData.map((item, index) => (
              <Link to={item.link}>
                <Button
                  key={index}
                  onClick={() => handleMoreSettingButtonClick(index)}
                  variant="contained"
                  sx={{
                    width: '100%',
                    height: '40px',
                    borderRadius: 2,
                    backgroundColor: activeMoreSettingButtons.includes(index)
                      ? theme.palette.primary.main
                      : theme.palette.info.main,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 0,
                  }}
                >
                  <img src={item.image} alt="" style={{ width: '24px', height: '24px' }} />
                </Button>
              </Link>

            ))}
          </Box>
        </Box>
      </Box>
    </div>

  );
};

export default Room;
